export const EVENTS = {
  ALPHA_COUNT_CHANGED: 'ALPHA_COUNT_CHANGED',
  ANIMATION: 'ANIMATION',
  ANIMATION_END: 'ANIMATION_END',
  ANIMATION_QUEUE_EMPTY: 'ANIMATION_QUEUE_EMPTY',
  BLOCK_HEIGHT_CHANGED: 'BLOCK_HEIGHT_CHANGED',
  CHARGE_LEVEL_CHANGED: 'CHARGE_LEVEL_CHANGED',
  CLEAR_ATTACK_TARGETS: 'CLEAR_ATTACK_TARGETS',
  CLEAR_DEFEND_TARGETS: 'CLEAR_DEFEND_TARGETS',
  CLEAR_MOVE_TARGETS: 'CLEAR_MOVE_TARGETS',
  CLEAR_STRUCT_TILE: 'CLEAR_STRUCT_TILE',
  CLEAR_TILE_SELECTION: 'CLEAR_TILE_SELECTION',
  ENERGY_USAGE_CHANGED: 'ENERGY_USAGE_CHANGED',
  FLEET_CHANGED: 'FLEET_CHANGED',
  GRASS_CONNECTED: 'GRASS_CONNECTED',
  LOGIN_COMPLETE: 'LOGIN_COMPLETE',
  LOTTIE_CUSTOMIZED: 'LOTTIE_CUSTOMIZED',
  ORE_COUNT_CHANGED: 'ORE_COUNT_CHANGED',
  PENDING_BUILD_ADDED: 'PENDING_BUILD_ADDED',
  PLANET_RAID_STATUS_CHANGED: 'PLANET_RAID_STATUS_CHANGED',
  REFRESH_ACTION_BAR: 'REFRESH_ACTION_BAR',
  REFRESH_ACTION_BAR_IF_SELECTED: 'REFRESH_ACTION_BAR_IF_SELECTED',
  REFRESH_ATTACK_TARGETS: 'REFRESH_ATTACK_TARGETS',
  RENDER_ALL_STRUCTS: 'RENDER_ALL_STRUCTS',
  RENDER_DEPLOYMENT_INDICATOR: 'RENDER_DEPLOYMENT_INDICATOR',
  RENDER_PLAYER_PFP: 'RENDER_PLAYER_PFP',
  RENDER_STRUCT_HUD: 'RENDER_STRUCT_HUD',
  RENDER_STRUCT: 'RENDER_STRUCT',
  SHOW_MOVE_TARGETS: 'SHOW_MOVE_TARGETS',
  UPDATE_TILE_STRUCT_ID: 'UPDATE_TILE_STRUCT_ID',
  SAVE_GAME_STATE: 'SAVE_GAME_STATE',
  SHIELD_HEALTH_CHANGED: 'SHIELD_HEALTH_CHANGED',
  SHOW_ATTACK_TARGETS: 'SHOW_ATTACK_TARGETS',
  SHOW_DEFEND_TARGETS: 'SHOW_DEFEND_TARGETS',
  SHOW_STRUCT_STILL: 'SHOW_STRUCT_STILL',
  SIGNING_TRANSACTION_SETTLED: 'SIGNING_TRANSACTION_SETTLED',
  STRUCT_COUNT_CHANGED: 'STRUCT_COUNT_CHANGED',
  STRUCT_SELECTION_CHANGED: 'STRUCT_SELECTION_CHANGED',
  TASK_CMD_AWAIT_REFINE_WORK: 'TASK_CMD_AWAIT_REFINE_WORK',
  TASK_CMD_KILL: 'TASK_CMD_KILL',
  TASK_CMD_MANAGER_PAUSE: 'TASK_CMD_MANAGER_PAUSE',
  TASK_CMD_MANAGER_RESUME: 'TASK_CMD_MANAGER_RESUME',
  TASK_CMD_PAUSE: 'TASK_CMD_PAUSE',
  TASK_CMD_RECONCILE: 'TASK_CMD_RECONCILE',
  TASK_CMD_REFRESH_ORE: 'TASK_CMD_REFRESH_ORE',
  TASK_CMD_RESUME: 'TASK_CMD_RESUME',
  TASK_CMD_SPAWN: 'TASK_CMD_SPAWN',
  TASK_CMD_FORCE_RUN: 'TASK_CMD_FORCE_RUN',
  TASK_CMD_SWEEP: 'TASK_CMD_SWEEP',
  TASK_CMD_SWEEP_ALL: 'TASK_CMD_SWEEP_ALL',
  TASK_COMPLETED: 'TASK_COMPLETED',
  TASK_STATE_CHANGED: 'TASK_STATE_CHANGED',
  TASK_MANAGER_STATUS_CHANGED: 'TASK_MANAGER_STATUS_CHANGED',
  TASK_WORKER_CHANGED: 'TASK_WORKER_CHANGED',
  TRACK_DESTROYED_STRUCT: 'TRACK_DESTROYED_STRUCT',
  TRACK_DESTROYED_STRUCTS: 'TRACK_DESTROYED_STRUCTS',
  UNDISCOVERED_ORE_COUNT_CHANGED: 'UNDISCOVERED_ORE_COUNT_CHANGED',
};
